import {
  setOrderCoordsData,
  setSelectedCity,
} from '../../../actions';
import { identityPayload, createReducer, forAction } from '../../../utils';

const initialState = null;

export default createReducer(
  [forAction(setOrderCoordsData, identityPayload)],
  initialState,
  [setSelectedCity],
);
